import { render, staticRenderFns } from "./commercialAgent.vue?vue&type=template&id=5ac5f210&"
import script from "./commercialAgent.vue?vue&type=script&lang=js&"
export * from "./commercialAgent.vue?vue&type=script&lang=js&"
import style0 from "./commercialAgent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports